export const capabilitiesList = [
  // editor
  'editor',
  'editor.draft',
  'editor.draft.create',
  'editor.draft.update',
  'editor.draft.update.targeting',
  'editor.draft.update.content',
  'editor.draft.update.newsletter',
  'editor.draft.update.occasion',
  'editor.draft.update.survey',
  'editor.draft.update.reminders',
  'editor.draft.update.documents',
  'editor.draft.delete',
  'editor.draft.customDeny',
  'editor.planned',
  'editor.published',
  // management
  'management',
  'management.list',
  'management.list.create',
  'management.list.update',
  'management.list.delete',
  'management.list.customDeny',
  // settings
  'settings'
] as const;

export type Capability = (typeof capabilitiesList)[number];
export type Capabilities = Record<Capability, boolean> & {
  // contains any sub-capability
  [K in Capability as `${K}.*`]: boolean;
};
